import { z } from 'zod'

// Token amount as returned by formatUnits, e.g. '1.23456789', what the user
// sees/enters. Validation messages are empty: an empty or non-positive amount
// blocks form submission but never surfaces a "fix this field" toast to the
// user — the disabled submit button is enough signal.
export const amountSchema = z
  .string()
  .min(1, { message: '' })
  .refine(
    (amount) => {
      const value = parseFloat(amount)
      return Number.isFinite(value) && value > 0
    },
    { message: '' },
  )
